export const queryKeysAssetReparsing = {
  base: () => 'reparsingAsset' as const,
  deleteReparsingAsset: () =>
    [queryKeysAssetReparsing.base(), 'delete'] as const,
  getAll: () => [queryKeysAssetReparsing.base(), 'list'] as const,
  getAllInfinite: (searchParams) =>
    [queryKeysAssetReparsing.base(), 'list', 'infinite', searchParams] as const,
  getDlnFile: (originalDlnFileName: string) =>
    [
      queryKeysAssetReparsing.base(),
      'originalDlnFile',
      { originalDlnFileName },
    ] as const,
  updateReparsingInputData: (reparsingId: string) =>
    [
      queryKeysAssetReparsing.base(),
      'updateReparsingInputData',
      { reparsingId },
    ] as const,
} as const;
